import classNames from "classnames";
import { IS_PRIMARY_VERSION, SUBMISSION_DISABLED } from "../../constants";

export const Tooltip = ({
  children,
}: {
  children: JSX.Element[] | JSX.Element;
}) => (
  <div
    className={classNames("popup__action", { disabled: SUBMISSION_DISABLED })}
  >
    {children}
    {SUBMISSION_DISABLED && !IS_PRIMARY_VERSION ? (
      <div className="tooltip">
        This is a preview link, create live links to allow customers to accept
      </div>
    ) : null}
  </div>
);
